// import {
//   Box,
//   Button,
//   Card,
//   CardActions,
//   CardContent,
//   Container,
//   Skeleton,
//   Typography,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { useCookies } from "react-cookie";
// import { config } from "../../config/config";
// import EastIcon from "@mui/icons-material/East";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import { Swiper, SwiperSlide } from "swiper/react";
// import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
// import { apiList, invokeApi } from "../../apis/apiServices";
// import { PriceFormatter, formatSegment } from "../../common/common";
// import { Link, useNavigate } from "react-router-dom";
// import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
// // import required modules
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import PropertyCard from "./exclusive-property-section/PropertyCard";
// import LeadForm from "../end-user/PropertyDetails/LeadForm";
// const emptyPropertyImage = "/media/images/gridimgae.jpeg";

// const LatestPropertiesSection = () => {
//   const [cookies] = useCookies();
//   const navigate = useNavigate();

//   const [leadModal, setLeadModal] = useState(false);
//   const [leadSource, setLeadSource] = useState("");
//   const [propertyId, setPropertyId] = useState(null);

//   const [isPropertiesFetching, setIsPropertiesFetching] = useState(true);
//   const [propertiesList, setPropertiesList] = useState([]);

//   const handeChangeModal = () => setLeadModal((prevState) => !prevState)

//   function handleEnquiry(propertyId, propertyType) {
//     handeChangeModal();
//     setPropertyId(propertyId);
//     setLeadSource(propertyType);
//   }

//   useEffect(() => {
//     const propertiesList = async () => {
//       let params = {};
//       const response = await invokeApi(
//         config.apiDomains + apiList.AllActiveProperties,
//         params,
//         cookies
//       );
//       if (response?.status >= 200 && response?.status < 300) {
//         if (response?.data.responseCode === "200") {
//           setPropertiesList(response.data.propertyDtl);
//         } else {
//           alert("An error occurred while fetching latest data!");
//         }
//       } else {
//         alert("An error occurred while fetching latest data!!");
//       }
//     };
//     if (isPropertiesFetching && !propertiesList.length > 0) {
//       propertiesList();
//       setIsPropertiesFetching(false);
//     }
//   }, [cookies, isPropertiesFetching]);

//   return (
//     <>
//       {/* latest property list start  */}
//       <Box component="section" sx={{ py: { md: 10, xs: 5 } }}>
//         <Container maxWidth={"lg"}>
//           <Box className="primary-heading-container">
//             <Typography variant="h2" className="section-primary-heading">
//               Latest Properties in {cookies[config.preferencesCookie]?.country}
//             </Typography>
//           </Box>
//           <Swiper
//             watchSlidesProgress={true}
//             pagination={{ clickable: true }}
//             navigation={true}
//             modules={[Pagination, Navigation, Autoplay]}
//             autoplay={{
//               delay: 3000, // Adjust time interval (3000ms = 3 seconds)
//               disableOnInteraction: false, // Keeps autoplay running even after user interaction
//             }}
//             slidesPerView={1}
//             spaceBetween={10}
//             breakpoints={{
//               640: { slidesPerView: 2, spaceBetween: 10 },
//               1024: { slidesPerView: 3, spaceBetween: 15 },
//             }}
//             loop={true} // Enable loop only if enough slides
//             className="mySwiper"
//           >
//             {propertiesList.length > 0
//               ? propertiesList.map((property, index) => (
//                 <SwiperSlide key={index}>
//                   <PropertyCard property={property} handleEnquiry={() => handleEnquiry(property.propertyId, property.propertyType)} />
//                 </SwiperSlide>
//               ))
//               : Array.from({ length: 15 }, (_, index) => (
//                 <SwiperSlide key={index}>
//                   <SkeletonCard />
//                 </SwiperSlide>
//               ))}
//           </Swiper>
//           <Box sx={{ py: { md: 2, xs: 1 }, textAlign: "center" }}>
//             <Link
//               to={`/property/${formatSegment(
//                 cookies[config.preferencesCookie]?.listingType
//               )}`}
//               style={{
//                 display: "flex",
//                 alignContent: "center",
//                 justifyContent: "center",
//                 textDecoration: "none",
//                 color: "red",
//                 fontWeight: "700",
//               }}
//             >
//               View Other Properties <ArrowRightAltIcon />
//             </Link>
//           </Box>
//         </Container>
//       </Box>
//       {/* latest property list end  */}

//       <LeadForm
//         isOpen={leadModal}
//         onClose={() => setLeadModal(false)}
//         leadSource={leadSource}
//         propertyId={propertyId}
//       />
//     </>
//   );
// };

// const SkeletonCard = () => (
//   <Card sx={{ margin: "0 5px", minHeight: "290px", zIndex: 1 }}>
//     <Skeleton variant="rectangular" width="100%" height={150} />
//     <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
//       <Skeleton width="60%" />
//       <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
//         <Skeleton width={80} height={30} />
//         <Skeleton width={80} height={30} />
//       </Box>
//     </CardContent>
//   </Card>
// );

// export default LatestPropertiesSection;

























import {
  Box,
  Container,
  Skeleton,
  Typography,
  Chip,
  IconButton,
  Card,
  CardContent,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useCookies } from "react-cookie";
import { config } from "../../config/config";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { apiList, invokeApi } from "../../apis/apiServices";
import { Link, useNavigate } from "react-router-dom";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import PropertyCard from "./exclusive-property-section/PropertyCard";
import LeadForm from "../end-user/PropertyDetails/LeadForm";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";



const LatestPropertiesSection = () => {
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const swiperRef = useRef(null);

  const [leadModal, setLeadModal] = useState(false);
  const [leadSource, setLeadSource] = useState("");
  const [propertyId, setPropertyId] = useState(null);

  const [isPropertiesFetching, setIsPropertiesFetching] = useState(true);
  const [propertiesList, setPropertiesList] = useState([]);

  const handeChangeModal = () => setLeadModal((prevState) => !prevState);

  useEffect(() => {
    const fetchProperties = async () => {
      let params = {};
      const response = await invokeApi(
        config.apiDomains + apiList.AllActiveProperties,
        params,
        cookies
      );
      if (response?.status >= 200 && response?.status < 300) {
        if (response?.data.responseCode === "200") {
          setPropertiesList(response.data.propertyDtl);
        } else {
          console.log("An error occurred while fetching latest data!");
        }
      } else {
        console.log("An error occurred while fetching latest data!!");
      }
    };
    if (isPropertiesFetching && !propertiesList.length > 0) {
      fetchProperties();
      setIsPropertiesFetching(false);
    }
  }, [cookies, isPropertiesFetching]);

  function handleEnquiry(propertyId, propertyType) {
    handeChangeModal();
    setPropertyId(propertyId);
    setLeadSource(propertyType);
  }

  const finalPropertyList =
    propertiesList && propertiesList.length > 0
      ? propertiesList
      : [];

  return (
    <>
      <Box
        component="section"
        sx={{
          py: { xs: 4, sm: 5, md: 6 },
          backgroundColor: '#f8fafc',
          position: 'relative',
          borderTop: '1px solid #e5e7eb',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            px: { xs: 2, sm: 3 },
            position: 'relative',
          }}
        >
          {/* Header */}
          <Box sx={{ textAlign: "center", mb: { xs: 3, sm: 4, md: 5 } }}>
            <Chip
              icon={<TrendingUpIcon />}
              label="LATEST PROPERTIES"
              sx={{
                backgroundColor: '#fee2e2',
                color: '#dc2626',
                fontWeight: 700,
                mb: 2,
                px: 2,
                py: 1,
                fontSize: { xs: '0.7rem', sm: '0.75rem' },
                letterSpacing: '0.5px',
                '& .MuiChip-icon': {
                  color: '#dc2626',
                  fontSize: { xs: '16px', sm: '18px' }
                }
              }}
            />

            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "24px", sm: "30px", md: "36px" },
                color: '#111827',
                mb: 1,
                lineHeight: 1.2,
              }}
            >
              Latest Properties in{' '}
              <Box
                component="span"
                sx={{
                  color: '#dc2626',
                  position: 'relative',
                  '&::after': {
                    content: '""',
                    position: 'absolute',
                    bottom: '2px',
                    left: 0,
                    width: '100%',
                    height: '4px',
                    backgroundColor: 'rgba(220, 38, 38, 0.1)',
                    borderRadius: '2px',
                  }
                }}
              >
                {cookies[config.preferencesCookie]?.country || "India"}
              </Box>
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#6b7280',
                fontSize: { xs: "14px", sm: "15px", md: "16px" },
                maxWidth: '600px',
                mx: 'auto',
                lineHeight: 1.6,
              }}
            >
              Discover our newest additions - fresh properties with modern amenities and great value
            </Typography>
          </Box>

          {/* Swiper Container with Arrows */}
          <Box sx={{
            position: 'relative',
            '& .swiper': {
              padding: '20px 10px 50px !important',
            },
            '& .swiper-pagination': {
              bottom: '20px !important',
              position: 'absolute',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
            },
            '& .swiper-pagination-bullet': {
              width: '8px',
              height: '8px',
              backgroundColor: '#d1d5db',
              opacity: 1,
              transition: 'all 0.3s ease',
            },
            '& .swiper-pagination-bullet-active': {
              backgroundColor: '#dc2626',
              width: '24px',
              borderRadius: '4px',
            },
          }}>
            {/* Left Arrow */}
            <IconButton
              onClick={() => swiperRef.current?.slidePrev()}
              sx={{
                position: 'absolute',
                left: { xs: '8px', sm: '0', md: '-20px' },
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                width: { xs: 36, sm: 40, md: 44 },
                height: { xs: 36, sm: 40, md: 44 },
                zIndex: 10,
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  backgroundColor: '#dc2626',
                  color: 'white',
                  borderColor: '#dc2626',
                  transform: 'translateY(-50%) scale(1.05)',
                },
                transition: 'all 0.2s ease',
              }}
            >
              <NavigateBeforeIcon sx={{ fontSize: { xs: 18, sm: 20, md: 22 } }} />
            </IconButton>

            {/* Right Arrow */}
            <IconButton
              onClick={() => swiperRef.current?.slideNext()}
              sx={{
                position: 'absolute',
                right: { xs: '8px', sm: '0', md: '-20px' },
                top: '50%',
                transform: 'translateY(-50%)',
                backgroundColor: 'white',
                border: '1px solid #e5e7eb',
                width: { xs: 36, sm: 40, md: 44 },
                height: { xs: 36, sm: 40, md: 44 },
                zIndex: 10,
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                  backgroundColor: '#dc2626',
                  color: 'white',
                  borderColor: '#dc2626',
                  transform: 'translateY(-50%) scale(1.05)',
                },
                transition: 'all 0.2s ease',
              }}
            >
              <NavigateNextIcon sx={{ fontSize: { xs: 18, sm: 20, md: 22 } }} />
            </IconButton>

            {/* Swiper */}
            <Swiper
              onSwiper={(swiper) => {
                swiperRef.current = swiper;
              }}
              watchSlidesProgress={true}
              pagination={{
                clickable: true,
                dynamicBullets: false,
              }}
              navigation={false}
              modules={[Pagination, Navigation, Autoplay]}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              slidesPerView={1}
              spaceBetween={20}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 20 },
                900: { slidesPerView: 3, spaceBetween: 24 },
                1200: { slidesPerView: 3, spaceBetween: 24 },
                1400: { slidesPerView: 3, spaceBetween: 24 },
              }}
              loop={true}
            >
              {finalPropertyList.length > 0
                ? finalPropertyList.map((property, index) => (
                  <SwiperSlide key={index}>
                    <PropertyCard
                      property={property}
                      handleEnquiry={() =>
                        handleEnquiry(property.propertyId, property.propertyType)
                      }
                    />
                  </SwiperSlide>
                ))
                : Array.from({ length: 3 }, (_, index) => (
                  <SwiperSlide key={index}>
                    <SkeletonCard />
                  </SwiperSlide>
                ))}
            </Swiper>
          </Box>

          {/* View All Properties Link */}
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Link
              to={`/property/${cookies[config.preferencesCookie]?.listingType || 'sale'}`}
              style={{ textDecoration: 'none' }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1,
                  color: '#dc2626',
                  fontWeight: 600,
                  fontSize: { xs: '15px', sm: '16px' },
                  padding: '10px 20px',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                  border: '1px solid #fee2e2',
                  transition: 'all 0.2s ease',
                  '&:hover': {
                    backgroundColor: '#fef2f2',
                    borderColor: '#dc2626',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 4px 12px rgba(220, 38, 38, 0.1)',
                  }
                }}
              >
                View All Properties
                <ArrowRightAltIcon sx={{ fontSize: { xs: 18, sm: 20 } }} />
              </Box>
            </Link>
          </Box>

          {/* Property Count */}
          <Box sx={{ textAlign: 'center', mt: 3 }}>
            <Typography
              variant="body2"
              sx={{
                color: '#6b7280',
                fontSize: { xs: '13px', sm: '14px' },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 1,
              }}
            >
              <LocationOnIcon sx={{ fontSize: { xs: 14, sm: 16 }, color: '#dc2626' }} />
              Showing {finalPropertyList.length} latest properties
            </Typography>
          </Box>
        </Container>
      </Box>

      <LeadForm
        isOpen={leadModal}
        onClose={() => setLeadModal(false)}
        leadSource={leadSource}
        propertyId={propertyId}
      />
    </>
  );
};

const SkeletonCard = () => (
  <Card
    sx={{
      height: '100%',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <Skeleton
      variant="rectangular"
      width="100%"
      height={180}
      sx={{ bgcolor: '#f3f4f6' }}
    />
    <CardContent sx={{ p: 2.5, flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Skeleton
        width="80%"
        height={20}
        sx={{ mb: 1.5, bgcolor: '#f3f4f6' }}
      />
      <Skeleton
        width="60%"
        height={18}
        sx={{ mb: 2, bgcolor: '#f3f4f6' }}
      />
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 1,
        mb: 2,
        justifyContent: 'center',
        alignItems: 'center',
      }}>
        <Skeleton
          width="100%"
          height={26}
          sx={{ borderRadius: '4px', bgcolor: '#f3f4f6' }}
        />
        <Skeleton
          width="100%"
          height={26}
          sx={{ borderRadius: '4px', bgcolor: '#f3f4f6' }}
        />
        <Skeleton
          width="100%"
          height={26}
          sx={{ borderRadius: '4px', bgcolor: '#f3f4f6' }}
        />
      </Box>
      <Box sx={{
        display: 'flex',
        gap: 1,
        mt: 'auto',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}>
        <Skeleton
          width="48%"
          height={36}
          sx={{ borderRadius: '6px', bgcolor: '#f3f4f6' }}
        />
        <Skeleton
          width="48%"
          height={36}
          sx={{ borderRadius: '6px', bgcolor: '#f3f4f6' }}
        />
      </Box>
    </CardContent>
  </Card>
);

export default LatestPropertiesSection;